import React from "react";
import styles from "./TomatoButton.module.css";

interface TomatoProps {
  classes?: string;
}

export default function TomatoButton({
  classes,
  children,
  ...props
}: React.ButtonHTMLAttributes<any> & TomatoProps) {
  return (
    <div className={styles.container}>
      <button
        className={`${classes} ${styles.button} `}
        type="button"
        {...props}
      >
        {children}
      </button>
    </div>
  );
}
